import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.white};
  height: 100vh;
  padding: 75px 20px 0 250px;
  overflow: auto;
  width: 100vw;
  max-width: 100vw;

  @media only screen and (max-width: 1024px) {
    padding: 50px 10px;
  }
`;

export const StyledTitle = styled.h1`
  font-size: 2.5rem !important;
  margin-bottom: 1.5rem;
`;

export const Section = styled.section`
  margin-bottom: 2.5rem;
`;

export const ChangelogContent = styled.pre`
  background: #f7f7f7;
  border-radius: 8px;
  padding: 18px;
  font-family: 'Fira Mono', 'Consolas', monospace;
  font-size: 1rem;
  overflow-x: auto;
  white-space: pre-wrap;
  line-height: 1.6;
`;
